import { render } from "./AdminNavbar.vue?vue&type=template&id=aa043144"
import script from "./AdminNavbar.vue?vue&type=script&lang=js"
export * from "./AdminNavbar.vue?vue&type=script&lang=js"

import "./AdminNavbar.vue?vue&type=style&index=0&id=aa043144&lang=css"

import exportComponent from "D:\\fclinique\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__